(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver = null;
  let ticking = false;

  function initReveals(root) {
    const scope = root || document;
    const nodes = scope.querySelectorAll('[data-v21-reveal]:not(.is-inview)');
    if (!nodes.length) return;

    if (REDUCE.matches || (window.Shopify && Shopify.designMode)) {
      nodes.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    nodes.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  function updateParallax() {
    if (REDUCE.matches) return;

    document.querySelectorAll('[data-v21-parallax]').forEach(function (el) {
      const media = el.querySelector('[data-v21-parallax-media]') || el;
      const rect = el.getBoundingClientRect();
      const viewH = window.innerHeight || 1;
      const progress = (viewH - rect.top) / (viewH + rect.height);
      const clamped = Math.min(Math.max(progress, 0), 1);
      const intensity = parseFloat(el.getAttribute('data-v21-parallax')) || 12;
      const offset = (clamped - 0.5) * intensity;
      media.style.transform = 'translate3d(0, ' + offset + '%, 0) scale(1.08)';
    });
  }

  function updateStackCards() {
    if (REDUCE.matches) return;

    document.querySelectorAll('[data-v21-stack]').forEach(function (stack) {
      const cards = stack.querySelectorAll('[data-v21-stack-card]');
      const viewH = window.innerHeight || 1;

      cards.forEach(function (card, index) {
        const rect = card.getBoundingClientRect();
        const stickyTop = parseFloat(window.getComputedStyle(card).top) || 0;
        const stuck = rect.top <= stickyTop + 1;
        let scale = 1;
        let brightness = 1;

        if (stuck && index < cards.length - 1) {
          const next = cards[index + 1];
          const nextRect = next.getBoundingClientRect();
          const travel = Math.min(Math.max((stickyTop + 80 - nextRect.top) / (viewH * 0.35), 0), 1);
          scale = 1 - travel * 0.06;
          brightness = 1 - travel * 0.35;
        }

        const inner = card.querySelector('[data-v21-stack-inner]') || card;
        inner.style.transform = 'scale(' + scale + ')';
        inner.style.filter = 'brightness(' + brightness + ')';
      });
    });
  }

  function onFrame() {
    ticking = false;
    updateParallax();
    updateStackCards();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onFrame);
  }

  function init() {
    initReveals(document);
    onFrame();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
    onFrame();
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:reorder', init);
  }
})();
